import AdminLayout from "../../commponents/layout/adminLayout";
import ProductForm from "../../commponents/product/productForm";
import ProductImages from "../../commponents/product/productImages";
import { getProductById, updateProduct } from "../../api/productApi";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getCategory } from "../../api/categoryApi";
import { getSubCategoryByCategory } from "../../api/subCategoryApi";
import { showError, showSuccess } from "../../utils/ alert";



export interface ProductDescription {
  id: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

export interface DescriptionForm {
  id?: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

export interface ProductImage {
  id: number;
  image: string;
}

export interface ProductCategory {
  id: number;
  name: string;
}

export interface ProductDetail {
  id: number;
  name: string;
  slug: string;
  category: ProductCategory;
  subCategory: ProductCategory;
  status: boolean;

  productImages: ProductImage[];
  productDemoImages: ProductImage[];

  descriptions: ProductDescription[];
}

interface Category {
  id: number;
  categoryName: string;
}

interface SubCategory {
  id: number;
  subCategoryname: string;
}

export type ImageItem = File | ProductImage;

export default function EditProduct() {

  const navigate = useNavigate();

  const [name, setName] = useState("");

  const [categories, setCategory] = useState<Category[]>([]);
  const [subCategories, setSubCategories] = useState<SubCategory[]>([]);

  const [categoryId, setCategoryId] = useState(0);

  const [subCategoryId, setSubCategoryId] = useState(0);

  const [isActive, setIsActive] = useState(true);

 const [descriptions, setDescriptions] = useState<DescriptionForm[]>([
   {
     type: "",
     standardMaterial: "",
     pressure: "",
     temperature: "",
     surfaceSpeed: "",
     stock: 0,
     unlimited: false,
   },
 ]);

  const [productImages, setProductImages] = useState<ImageItem[]>([]);

  const [productDemoImages, setProductDemoImages] = useState<ImageItem[]>([]);
const [deletedProductImageIds, setDeletedProductImageIds] = useState<number[]>(
  []
);
const [deletedDemoImageIds, setDeletedDemoImageIds] = useState<number[]>([]);



 const [pageLoading, setPageLoading] = useState(true);

 const [submitLoading, setSubmitLoading] = useState(false);

  const handleRemoveProductImage = (item: ImageItem) => {
    if (!(item instanceof File)) {
      setDeletedProductImageIds((prev) => [...prev, item.id]);
    }

    setProductImages((prev) => prev.filter((img) => img !== item));
  };

  const handleRemoveDemoImage = (item: ImageItem) => {
    if (!(item instanceof File)) {
      setDeletedDemoImageIds((prev) => [...prev, item.id]);
    }

    setProductDemoImages((prev) => prev.filter((img) => img !== item));
  };
  
  
  const { id } = useParams();

  const handleSubmit = async () => {
    if (!id) return;

    try {
      setSubmitLoading(true);

      const formData = new FormData();

      formData.append("name", name);
      formData.append("categoryId", String(categoryId));
      formData.append("subCategoryId", String(subCategoryId));
      formData.append("isActive", String(isActive));
      formData.append("descriptions", JSON.stringify(descriptions));

      productImages.forEach((item) => {
        if (item instanceof File) {
          formData.append("productImages", item);
        }
      });

      productDemoImages.forEach((item) => {
        if (item instanceof File) {
          formData.append("productDemoImages", item);
        }
      });

      formData.append(
        "deletedProductImageIds",
        JSON.stringify(deletedProductImageIds)
      );

      formData.append(
        "deletedDemoImageIds",
        JSON.stringify(deletedDemoImageIds)
      );

      await updateProduct(Number(id), formData);

      await showSuccess("Product updated successfully");
      navigate("/product");
    } catch (error) {
      // console.error(error);
      showError("Failed to update product");
    } finally {
      setSubmitLoading(false);
    }
  };

  


   const fetchProduct = async () => {
     try {
      setPageLoading(true);

       const response = await getProductById(Number(id));

       const data = response.data.data;

     

       setName(data.name);
       setCategoryId(data.category.id);
       setSubCategoryId(data.subCategory.id);
       setIsActive(data.status);
       setDescriptions(data.descriptions);

       setProductImages(data.productImages);

       setProductDemoImages(data.productDemoImages);
     } catch (error) {
      //  console.error(error);
     } finally {
    setPageLoading(false);
     }
   };
  
  useEffect(() => {
    if (!id) return;

    fetchProduct();
  }, [id]);

  const fetchCategory = async () => {
    try {
      const response = await getCategory({
        page: 1,
        limit: 10,
      });

      setCategory(response.data.categoryList);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const fetchSubCategories = async (categoryId: number) => {
    try {
      const response = await getSubCategoryByCategory(categoryId);

      setSubCategories(response.data.data.subCategoryList);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  useEffect(() => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }

    fetchSubCategories(categoryId);
  }, [categoryId]);


 if (pageLoading) {
   return (
     <AdminLayout>
       <div className="flex h-[70vh] items-center justify-center">
         <p className="text-lg font-medium text-gray-500">Loading product...</p>
       </div>
     </AdminLayout>
   );
 }
  
  
  
  
  return (
    <AdminLayout>
      <div className="rounded-[32px] bg-white p-8">
        <h1 className="mb-10 text-3xl font-bold text-gray-900">Edit Product</h1>

        <div className="grid grid-cols-12 gap-12">
          {/* Left */}
          <div className="col-span-7">
            <ProductForm
              name={name}
              categories={categories}
              subCategories={subCategories}
              setName={setName}
              categoryId={categoryId}
              setCategoryId={setCategoryId}
              subCategoryId={subCategoryId}
              setSubCategoryId={setSubCategoryId}
              isActive={isActive}
              setIsActive={setIsActive}
              descriptions={descriptions}
              setDescriptions={setDescriptions}
            />
          </div>

          {/* Right */}
          <div className="col-span-5">
            <ProductImages
              productImages={productImages}
              setProductImages={setProductImages}
              productDemoImages={productDemoImages}
              setProductDemoImages={setProductDemoImages}
              onRemoveProductImage={handleRemoveProductImage}
              onRemoveDemoImage={handleRemoveDemoImage}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 flex justify-end gap-4">
          <button
            type="button"
            onClick={() => navigate("/product")}
            className="rounded-lg bg-red-600 px-8 py-3 font-semibold text-white transition hover:bg-red-700">
            Cancel
          </button>

          <button
            type="button"
            disabled={submitLoading}
            onClick={handleSubmit}
            className="rounded-lg bg-green-600 px-8 py-3 font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50">
            {submitLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
